import { __decorate } from "tslib";
import { AutoEncoder, StringDecoder, field, IntegerDecoder, ArrayDecoder } from '@simonbackx/simple-encoding';
import { upgradePriceFrom2To4DecimalPlaces } from '../upgradePriceFrom2To4DecimalPlaces.js';
export class UitpasPriceCheckRequest extends AutoEncoder {
    basePrice;
    /**
     * The reduced price in the non-official flow is an estimate, the response will have the effective price for this UiTPAS number
     * The reduced price can thus only be null when doing a static check (using uitpasEventUrl and without UiTPAS number) (e.g. when configuring the webshop)
     */
    reducedPrice;
    uitpasEventUrl;
    uitpasNumbers;
}
__decorate([
    field({ decoder: IntegerDecoder }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], UitpasPriceCheckRequest.prototype, "basePrice", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true }),
    field({ ...upgradePriceFrom2To4DecimalPlaces, nullable: true })
], UitpasPriceCheckRequest.prototype, "reducedPrice", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], UitpasPriceCheckRequest.prototype, "uitpasEventUrl", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder), nullable: true })
], UitpasPriceCheckRequest.prototype, "uitpasNumbers", void 0);
export class UitpasPriceCheckResponse extends AutoEncoder {
    prices;
}
__decorate([
    field({ decoder: new ArrayDecoder(IntegerDecoder) })
], UitpasPriceCheckResponse.prototype, "prices", void 0);
//# sourceMappingURL=UitpasPriceCheckRequest.js.map